import React from 'react';
import Collapsible from './Collapsible';

const FooterMenus = (props) => {
  const menus = props.menuItems;
  return (
    <>
      {/* mobile menu */}
      {menus.map((menu) => (
        <div
          className="footer__menu"
          key={Math.random().toString(36).substring(2, 9)}
        >
          <Collapsible
            className="hide-for-medium header-6 collapsible-header"
            transitionDuration="0.2"
            label={menu.sectionTitle}
          >
            <div
              dangerouslySetInnerHTML={{ __html: menu.sectionText.value }}
            ></div>
            {menu.sectionLinkList.map((menuItem, idx) => (
              <div key={'footer-mobile' + menuItem.href + idx}>
                {menuItem.accessibleByUser && (
                  <a className="text-large" href={menuItem.href}>
                    {menuItem.text}
                  </a>
                )}
              </div>
            ))}
          </Collapsible>

          {/* desktop menu */}
          <div className="show-for-medium">
            <h6>{menu.sectionTitle}</h6>
            <div
              dangerouslySetInnerHTML={{ __html: menu.sectionText.value }}
            ></div>
            {menu.sectionLinkList.map((menuItem, idx) => (
              <div key={'footer-mobile' + menuItem.href + idx}>
                {menuItem.accessibleByUser && (
                  <a className="text-large" href={menuItem.href}>
                    {menuItem.text}
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default FooterMenus;
